import { put, call, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { flashMessage } from "redux-flash";

import {
  GET_NBVISITE_REQUEST,
  getNbVisiteSuccess,
  getNbVisiteError,
  GET_TOP3CATEG_REQUEST,
  getTop3CategoryVisitedSuccess,
  getTop3CategoryVisitedError,
  GET_RESETSTATSMONTHLY_REQUEST,
  resetStatsMonthlyError,
  GET_ARRAYVISITEYEARS_REQUEST,
  getArrayVisiteYearsSuccess,
  getArrayVisiteYearsError,
} from "./actions";
import { Env } from "../../../env";

//Function to reset all statistiques when we are in the new month
/**
 * @param action => Object {subdomain, month}
 */
function* resetStatsMonthlyRequest(action) {
  console.log("Saga Reset ", action.payload);
  let response;
  try {
    response = yield call(
      axios.get,
      `http://localhost:3001/api/Accounts/resetStatsMonthly?subdomain=test.digidocteur.com&month=${action.payload.month}`
    );
    console.log("Rep saga reset ", response.data.status);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      yield put(flashMessage(error));
    } else {
      yield put(
        resetStatsMonthlyError(
          "Something is wrong in resetStatsMonthlyRequest ",
          error.response
        )
      );
    }
    return;
  }
}
export function* watchResetStatsMonthlyRequest() {
  yield takeLatest(GET_RESETSTATSMONTHLY_REQUEST, resetStatsMonthlyRequest);
}

//Function to get arrayVisiteYears
/**
 *
 * @param action => Object subdomain
 */

function* getArrayVisiteYearsRequest(action) {
  // console.log('Dans le sage de array ', action.payload)
  let res;
  try {
    res = yield call(
      axios.get,
      `http://localhost:3001/api/Accounts/getArrayVisiteYears?subdomain=${action.payload}`
    );
    // console.log('Réponse saga array years ', res.data.data.arrayAllVisite)
  } catch (error) {
    if (error.response && error.response.status === 401) {
      yield put(flashMessage(error));
    } else {
      yield put(
        getArrayVisiteYearsError(
          "Something is wrong in getArrayVisiteYearsRequest ",
          error.reponse
        )
      );
    }
    return;
  }
  yield put(getArrayVisiteYearsSuccess(res.data.data.arrayAllVisite));
}

export function* watchgetArrayVisiteYearsRequest() {
  yield takeLatest(GET_ARRAYVISITEYEARS_REQUEST, getArrayVisiteYearsRequest);
}

//Get the Top 3 categories
//Function to reset all statistiques when we are in the new month
/**
 * @param action => Object {specialityId}
 */
function* getTop3CategoryVisitedRequest(action) {
  const specialityId = action.payload;
  let response;
  try {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Categories/getTop3CategoryVisited?specialityId=${specialityId}`
    );
    // Create tab to send on the component
    var tab = {
      top3: {
        top1: response.data.data.top1.nbViews,
        top2: response.data.data.top2.nbViews,
        top3: response.data.data.top3.nbViews,
      },
      name: {
        name1: response.data.data.top1.name,
        name2: response.data.data.top2.name,
        name3: response.data.data.top3.name,
      },
    };
  } catch (error) {
    if (error.response && error.response.status === 401) {
      yield put(flashMessage(error));
    } else {
      yield put(
        getTop3CategoryVisitedError(
          "Something is wrong in Top3CategoryVisitedRequest ",
          error.response
        )
      );
    }
    return;
  }
  yield put(getTop3CategoryVisitedSuccess(tab));
}

export function* watchGetTop3CategoryVisitedRequest() {
  yield takeLatest(GET_TOP3CATEG_REQUEST, getTop3CategoryVisitedRequest);
}

//Function get the number we have on this website
/**
 * @param action => Object {subdomain}
 */
function* getNbVisiteRequest(action) {
  const subdomain = action.payload;
  let response;
  try {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Accounts/getNumberVisite?subdomain=${subdomain}`
    );
    console.log("saga stats nb ", response.data.data);
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(flashMessage(error));
    } else {
      yield put(
        getNbVisiteError(
          "Something is wrong in the NbVisitedRequest ",
          err.reponse
        )
      );
    }
    return;
  }
  yield put(getNbVisiteSuccess(response.data.data));
}

export function* watchgetNbVisiteRequest() {
  yield takeLatest(GET_NBVISITE_REQUEST, getNbVisiteRequest);
}



// WEBPACK FOOTER //
// ./src/pages/admin/stats/saga.js